import { View } from "@/components/ui";
import { IconButton } from "@/components/ui/icon-button";
import { Typography } from "@/components/shared/typography";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import { useRoute } from "@/components/shared/router";
import { AccountReferralHistory } from "@/containers/profile/account-my-referral/account-my-referral-history-component";
import { useSafeAreaInsets } from "@/components/hooks/use-safe-area-insets";
import { Divider } from "@/components/shared/divider";
import { ReferralHistoryFilter } from "@/containers/profile/account-my-referral/account-my-referral-history-component/referral-history-filter";
import { useState } from "react";
import {
  SortEnum,
  ClientReferralSortByEnum,
  ClientStatusReferralEnum,
} from "@/__generated__/graphql";

export const AccountMyReferralHistory = () => {
  const { top } = useSafeAreaInsets();
  const { isMobile } = useWindowDimensions();
  const { pull } = useRoute();
  const [status, setStatus] = useState<ClientStatusReferralEnum | "ALL">("ALL");

  return (
    <View style={{ paddingTop: top }}>
      <View className="flex flex-col gap-4 p-4">
        <View className="flex flex-row items-center justify-between py-2">
          <View className="flex flex-row items-center gap-4">
            <IconButton
              variant={isMobile ? "ghost" : "secondary"}
              color="foreground"
              iconName="arrowLeft"
              rounded="full"
              onClick={() => pull()}
            />
            <Typography variant="label-md">Referral History</Typography>
          </View>
          <ReferralHistoryFilter filter={status} setFilter={setStatus} />
        </View>
        <Divider />
        <AccountReferralHistory
          filter={{
            status,
            sort: [SortEnum.Desc],
            sortBy: [ClientReferralSortByEnum.UpdatedAt],
          }}
        />
      </View>
    </View>
  );
};
